export default {
  name: 'marking--bufferStatus',
};